import DeleteIcon from "@mui/icons-material/Delete";
import { memo, useState } from "react";
import { QuickReplyListItem, QuickReplyListWrapper } from "./QuickReply.style";
import { ConfirmationDialog } from "../../../common/ConfirmationDialog";
import { useTranslation } from "hhn-commons";

interface QuickReplyListProps {
  quickReplies: string[];
  onSend: (reply: string) => void;
  isManageMode: boolean;
  onDelete: (index: number) => void;
}

const QuickReplyList = memo(
  ({ quickReplies, onSend, isManageMode, onDelete }: QuickReplyListProps) => {
    const { t } = useTranslation();
    const tNs = (key: string) => t(key, { ns: "quickReply" });

    const [dialogOpen, setDialogOpen] = useState(false);
    const [deleteIndex, setDeleteIndex] = useState<number | null>(null);

    const handleDeleteClick = (index: number) => {
      setDeleteIndex(index);
      setDialogOpen(true);
    };

    const handleConfirmDelete = () => {
      if (deleteIndex !== null) {
        onDelete(deleteIndex);
      }
      setDialogOpen(false);
      setDeleteIndex(null);
    };

    const handleCancelDelete = () => {
      setDialogOpen(false);
      setDeleteIndex(null);
    };

    return (
      <>
        <QuickReplyListWrapper data-testid="quick-replies-list">
          {quickReplies.map((reply, index) =>
            isManageMode ? (
              <QuickReplyListItem
                label={reply}
                key={index}
                variant="filled"
                data-testid="quick-reply-item-manage"
                onDelete={() => handleDeleteClick(index)}
                deleteIcon={<DeleteIcon fontSize="small" />}
              />
            ) : (
              <QuickReplyListItem
                label={reply}
                key={index}
                variant="filled"
                onClick={() => onSend(reply)}
                data-testid="quick-reply-item"
                color="primary"
                size="medium"
              />
            ),
          )}
        </QuickReplyListWrapper>
        <ConfirmationDialog
          isOpen={dialogOpen}
          onClose={handleCancelDelete}
          confirmationTitle={tNs("deleteDialogTitle")}
          confirmationMessage={tNs("deleteDialogMessage")}
          confirmationButtonText={tNs("deleteDialogConfirm")}
          confirmationCancelText={tNs("deleteDialogCancel")}
          onConfirmationAction={handleConfirmDelete}
        />
      </>
    );
  },
);

export default QuickReplyList;
